// we're not using redux, but this is a convenient way to share the apiEndpoint helper,
// that sticks with the conventions other apps are using
//
import railsFactory from '../../../../shared/ducks/rails_factory.js'

let rails = railsFactory("elasticube", {})
export const apiEndpoint = rails.apiEndpoint
